import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentReminderDeliveryReducer } from '../reducers';

export const selectPaymentReminderDeliveryFeature = createFeatureSelector<PaymentReminderDeliveryReducer.DataState>(PaymentReminderDeliveryReducer.featureName);

export const selectFeaturePaymentReminderDelivery = createSelector(selectPaymentReminderDeliveryFeature, (state: PaymentReminderDeliveryReducer.DataState) => state.detail);
